import React from 'react';
import './style.scss';

export default class SkillSelector extends React.Component {
	skills = ["Select",      
      "Effective communication",
      "Teamwork",
      "Responsibility",
      "Creativity",
      "Problem-solving",
      "Leadership",
      "Extroversion",
      "People skills",
      "Openness",
      "Adaptability",
      "Time management",
      "Effective communication",
      "Emotional intelligence",
      "Conflict management",
      "Teamwork skills",
      "Stress management",
      "Productivity &amp; organization",
      "Critical thinking",
      "Attention to detail",
      "Adaptability",
      "Data analysis",
      "Web analytics",
      "SEO/SEM",
      "HTML &amp; CSS",
      "Wordpress",
      "Email marketing",
      "Web scraping",
      "CRO and A/B Testing",
      "Data visualization &amp; pattern-finding through critical thinking",
      "Search Engine and Keyword Optimization",
      "Project/campaign management",
      "Social media and mobile marketing",
      "Paid social media advertisements",
      "B2B Marketing",
      "The 4 P-s of Marketing",
      "Consumer Behavior Drivers",
      "Brand management",
      "Creativity",
      "Copywriting",
      "Storytelling",
      "Sales",
      "CMS Tools",
      "Six Sigma techniques",
      "The McKinsey 7s Framework",
      "Porter’s Five Forces",
      "PESTEL",
      "Emotional Intelligence",
      "Dealing with work-related stress",
      "Motivation",
      "Task delegation",
      "Technological savviness",
      "People management",
      "Business Development",
      "Strategic Management",
      "Negotiation",
      "Planning",
      "Proposal writing",
      "Problem-solving",
      "Innovation",
      "Charisma",
      "Customer Relationship Management (CRM)",
      "Cold-calling",
      "Negotiation",
      "Public speaking",
      "Closing",
      "Lead generation",
      "Buyer-Responsive selling",
      "Buyer engagement",
      "Product knowledge",
      "Persuasion",
      "Effective communication and sociability",
      "Empathy",
      "Social media/digital communication",
      "Teamwork",
      "Time management",
      "Adobe Creative Suite: Illustrator, InDesign, Photoshop",
      "Dreamweaver",
      "Infographics",
      "HTML &amp; CSS",
      "Photo editing",
      "Typography: spacing, line height, layout, choosing fonts",
      "Storyboarding",
      "Targeting and marketing through visual communications",
      "Logo creation",
      "Digital printing",
      "Integration of visual communication in social media platforms",
      "Creativity",
      "Attention to detail &amp; aesthetics",
      "Interactive media design",
      "Color sense &amp; theory",
      "Ad design",
      "Active listening",
      "Microsoft Office Pack: Word, Excel, Access, Publisher, Outlook, Powerpoint",
      "Filing and paper management",
      "Data entry",
      "Bookkeeping through Excel or TurboTax",
      "Research and data analysis",
      "Basic knowledge of user interface communication",
      "Technical writing",
      "Cloud networking and file sharing",
      "Microsoft Excel (Advanced)",
      "Enterprise Resource Planning",
      "Big Data Analysis &amp; SQL",
      "Know Your Customers (KYC)",
      "Cognos Analytics (IBM)",
      "Visual Basic",
      "Accounting Software",
      "Revenue recognition",
      "Anti Money Laundering",
      "Clear communication",
      "General business knowledge",
      "Numerical competence",
      "Accuracy",
      "Attention to detailMicrosoft Excel (Advanced)",
      "Enterprise Resource Planning",
      "Big Data Analysis &amp; SQL",
      "Know Your Customers (KYC)",
      "Cognos Analytics (IBM)",
      "Visual Basic",
      "Accounting Software",
      "Revenue recognition",
      "Anti Money Laundering",
      "Clear communication",
      "General business knowledge",
      "Numerical competence",
      "Accuracy",
      "Attention to detail",
      "Updated curriculum knowledge",
      "Research &amp; Data analysis",
      "Communication",
      "Educational platforms (software like Elearn)",
      "Stress management",
      "Technological &amp; digital literacy",
      "Patience",
      "Critical thinking",
      "Enthusiasm",
      "Motivation",
      "HTML/CSS",
      "CSS preprocessors",
      "Javascript",
      "Wordpress",
      "Graphic User Interfaces (GUI)",
      "Git/Version control (Github, gitlab)",
      "Search Engine Optimization (SEO)",
      "Application Programming Interface (API)",
      "Adobe Photoshop, InDesign",
      "Content Management Systems (CMS)",
      "Testing/Debugging",
      "Responsive design principles",
      "SQL (a must) and Hive (optional)",
      "Programming language (R, Python, Scala, Matlab)",
      "STATA, SPSS, SAS",
      "Data Mapping",
      "Entity Relationship Diagrams",
      "Wireframes",
      "Big Data tools",
      "Microsoft Visio",
      "Agile Business Analysis",
      "Machine learning",
      "System Context Diagrams",
      "Business Process Modeling",
      "Technical and non-technical communication",
      "Mathematics",
      "CPR",
      "Patient care and assistance",
      "Paperwork/record-keeping abilities",
      "Compassion",
      "Advanced Cardiac Life Support (ACLS)",
      "Telemetry",
      "Attention to detail",
      "Physical endurance",
      "Acute care",
      "Infection control",
      "Surgery preparation"];

	render() {
		return (
			<select name={this.props.name} className="SkillSelector" required={this.props.required} onChange={this.props.onChange}>
				{
					this.skills.map((x) => {
						return (
							<option value={x}>
								{x}
							</option>
						)
					})
				}
			</select>
		);
	}
}